import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { finalize } from 'rxjs';

/**
 * Функция для автоматического выбора языка браузера
 */
export const translateInitializer = (): Promise<unknown> => {
  const locationInitialized =
    inject(LOCATION_INITIALIZED, { optional: true }) ?? Promise.resolve(null);
  const translateService = inject(TranslateService);

  return new Promise((resolve) => {
    locationInitialized.then(() => {
      translateService
        .use(translateService.getBrowserLang())
        .pipe(finalize(() => resolve(null)))
        .subscribe();
    });
  });
};
